<template>
  <div class="settings-user">
    <div class="row header-row">
      <div class="col-12 col-md-4">
        <h3 style="display: inline;">
          Current Vendors
        </h3>
        <span
          v-if="vendorListUploadedFiles && vendorListUploadedFiles.length"
          style="margin-left: 5px;"
        >
          <div
            v-for="(file, file_index) in vendorListUploadedFiles"
            :key="file_index"
            class="viewuploaded"
          >
            <a
              v-b-popover.hover.bottom="{ html: true, content: file.filename}"
              :href="file.url"
              target="_blank"
              style="margin: 2px;"
            >
              <i
                class="fa fa-download"
                aria-hidden="true"
              />
            </a>
          </div>
        </span>
      </div>
      <div class="col-12 col-md-8 text-right-md">
        <button
          class="btn btn-primary btn-add"
          style="margin-right: 10px;"
          type="button"
          @click="openUploadVendorListModal()"
        >
          <span>Upload List</span>
        </button>
        <button
          class="btn btn-primary btn-add"
          type="button"
          @click="addVendor()"
        >
          <font-awesome-icon
            :icon="['fas', 'plus']"
            class="icon alt"
          />
          <span>Add Vendor</span>
        </button>
      </div>
      <div class="col-12">
        <!-- Commenting the code as per New Mockup shared Feb 22 -->
        <!--p>
          Adding your current vendors will allow you to quickly compare criteria while using
          Virginia.
        </p-->
      </div>
    </div>

    <div
      v-if="!items"
      class="row"
    >
      <Loader :style="{width: '100%'}" />
    </div>

    <div
      v-else-if="items.length === 0"
      class="no-results"
    >
      <p>
        You haven't added any of your current vendors yet.
      </p>
    </div>

    <div v-else>
      <vendor-table
        v-if="vendorFields"
        :items="items"
        :edit-vendor="editVendor"
        :vendor-fields="vendorFields"
        :open-benchmark-modal="openBenchmarkModal"
      />

      <pagination
        v-if="count > limit"
        :filtered-count="count"
        :page="page"
        :page-size="limit"
        :on-page-changed="onPageChanged"
      />
    </div>

    <vendor-modal
      ref="addVendorModal"
      :on-vendor-added="loadItems"
      :delete-vendor="deleteVendor"
      :vendor-fields="vendorFields"
    />

    <vendor-list-upload-modal
      ref="vendorListUploadModal"
      :on-files-saved="(updatedFiles) => vendorListUploadedFiles = updatedFiles"
    />

    <confirm-modal
      ref="confirmModal"
      :title="confirmTitle"
      :body="confirmBody"
      :on-confirm="confirmAction"
      cancel-text="No"
    />
    <GetBenchmarkedModal
      ref="getBenchmarkedModal"
      :handle-confirm="updateBenchmarkForVendor"
    />
  </div>
</template>

<script>

import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import VendorTable from '@/components/tables/VendorTable.vue';
import VendorModal from '@/components/modals/VendorModal.vue';
import VendorListUploadModal from '@/components/modals/VendorListUploadModal.vue';
import Pagination from '@/components/Pagination.vue';
import Loader from '@/components/Loader.vue';
import UserClient from '@/api/UserClient';
import GetBenchmarkedModal from '@/components/modals/GetBenchmarkedModal.vue';

export default {
  name: 'Components',
  components: {
    VendorTable,
    VendorModal,
    VendorListUploadModal,
    Pagination,
    Loader,
    ConfirmModal,
    GetBenchmarkedModal
},
  data() {
    return {
      userClient: new UserClient(this.$http),
      model: null,
      items: null,
      vendorFields: [],
      count: 0,
      page: 1,
      limit: 50000,
      modaltype: 'add',

      confirmTitle: '',
      confirmBody: '',
      confirmAction: null,
      vendorListUploadedFiles: null,
    };
  },
  async mounted() {
    this.$store.commit('clearGlobalAlerts');
    try {
      this.vendorListUploadedFiles = await this.userClient.getVendorListUploadedFiles();
    }catch (e) {
      console.log(e);
      this.vendorListUploadedFiles = [];
    }
    this.loadItems();
  },
  methods: {
    loadItems() {
      this.items = null;
      this.vendorFields = null;
      const offset = (this.page - 1) * this.limit;
      this.userClient.getMyVendors(this.limit, offset).then((response) => {
        this.items = response.results;
        this.count = response.count;
        console.log(this.items);
      }).catch(ex => {
        console.error(ex);
        this.items = [];
        this.count = 0;
      });
      this.userClient.getCurrentVendorFields().then((response) => {
        this.vendorFields = response.results;
      }).catch(ex => {
        console.error(ex);
        this.vendorFields = [];
      });
      
    },
    deleteVendor(vendorId) {
      this.confirmTitle = 'Remove Vendor';
      this.confirmBody = 'Are you sure you want to remove this vendor?';

      this.confirmAction = (whenDone) => {
        this.userClient.removeCurrentVendor(vendorId).then((res) => {
          whenDone();
          this.$refs.confirmModal.hide();
          this.$refs.addVendorModal.hide();
          this.loadItems();
          this.$globals.showSuccess('Vendor Removed!');
        }).catch((ex) => {
          whenDone();
          this.$globals.showError('Failed to remove vendor. Please try again.', ex);
        });
      };
      this.$refs.confirmModal.show();
    },
    editVendor(vendor, event) {
      if (event) {
        event.preventDefault();
      }
      console.log(vendor);
      this.$refs.addVendorModal.show(vendor);
    },
    onPageChanged(page) {
      if (page !== this.page) {
        this.page = page;
        this.loadItems();
      }
    },
    addVendor() {
      this.$refs.addVendorModal.show(null);
    },
    openUploadVendorListModal() {
      this.$refs.vendorListUploadModal.show(this.vendorListUploadedFiles);
    },
    openBenchmarkModal(vendor){
      this.$refs.getBenchmarkedModal.openModal(vendor);
    },
    async updateBenchmarkForVendor(vendor){
      const result = await this.userClient.getCurrentVendorBenchmarked(vendor.id);
      console.log(result);
      if (result.success) {
        this.$refs.getBenchmarkedModal.closeModal();
        this.loadItems(); // Ensure `loadItems` method exists in this component or is passed as a prop.
      }
    }
    
  },
};
</script>

<style lang="scss" scoped>
.settings-user {
  padding: 30px 0 75px;
  padding-left: 15px;
  padding-right: 15px;

  .header-row {
    /deep/ .btn {
      position: relative;
      top: -8px;
    }
  }
}

.text-right-md {
  @media (min-width: $md-min) {
    text-align: right;
  }
}

.btn-add {
  i,
  svg {
    margin-right: 8px;
  }
}

.viewuploaded {
  display: inline;
  margin: 2px;
}

</style>
